// Submission + diagnostics access for the "Report a problem" form.
//
// In Electron this goes through IPC so the main process can enrich the report
// with OS version, Rekordbox version, recent logs, and the install ID. On web
// (no window.electron) it degrades to a direct POST with renderer-known
// diagnostics — same endpoint, same shape, fewer fields.
const ERROR_REPORTING_URL =
    process.env.REACT_APP_ERROR_REPORTING_URL ||
    'https://errors.mixgoat.com/api/v1/errors';

const REPORTS_URL = ERROR_REPORTING_URL.replace(/\/api\/v1\/errors$/, '') + '/api/v1/reports';

const ERROR_REPORTING_CLIENT_KEY =
    process.env.REACT_APP_ERROR_REPORTING_CLIENT_KEY || '';

const isElectron = typeof window !== 'undefined' && !!window.electron?.report;

export async function getReportDiagnostics() {
    if (isElectron) {
        try {
            return await window.electron.report.getDiagnostics();
        } catch {
            // fall through to the web shape
        }
    }
    return {
        appVersion: process.env.REACT_APP_VERSION || null,
        platform: 'web',
        arch: null,
        osVersion: typeof navigator !== 'undefined' ? navigator.userAgent : null,
        rekordboxVersion: null,
        installId: null,
        environment: process.env.NODE_ENV || 'production',
    };
}

export async function submitProblemReport(payload) {
    if (isElectron) {
        try {
            return await window.electron.report.submit(payload);
        } catch (err) {
            return { ok: false, error: 'Could not send the report. Please try again.' };
        }
    }
    try {
        const diagnostics = await getReportDiagnostics();
        const response = await fetch(REPORTS_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Key': ERROR_REPORTING_CLIENT_KEY,
            },
            body: JSON.stringify({ ...payload, ...diagnostics }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
            // Surface actionable server messages (rate limit, size) verbatim.
            return { ok: false, error: data.error || 'Could not send the report. Please try again.' };
        }
        return { ok: true, id: data.id ?? null, ref: data.ref ?? null };
    } catch {
        return { ok: false, error: 'Could not send the report. Check your connection and try again.' };
    }
}
